import React, {useEffect, useState} from 'react';
import {TrailRating} from "types/TrailRating";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "../../../context/NotificationContext";

type Props = {
    trailRating: TrailRating | null
    show: boolean
    onDelete?: (trailRating: TrailRating) => any
    onDeleteFail?: (trailRating: TrailRating, error: unknown) => any
    onCancel?: () => any
}

function DeleteTrailRating(props: Props) {
    const {trailRating, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(trailRating?.name || 'this trail rating');
    const {mutateAsync: deleteTrailRating} = useMutation(ngage.trailRatings.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(trailRating) setName(trailRating.name)
    }, [trailRating]);

    async function handleDeleteTrailRating() {
        if (trailRating) {
            try {
                await deleteTrailRating(trailRating.id)
                await invalidate('trail-ratings.all')

                notify("success", "Trail Rating Deleted", `${trailRating.name} has been permanently removed`)
                if (onDelete) onDelete(trailRating)
            } catch (error) {
                notify("error", "Trail Rating Not Deleted", `${trailRating.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(trailRating, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Trail Rating"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteTrailRating}
            onCancel={handleCancel}
        />
    );
}

export default DeleteTrailRating;